import { CIcon } from '~/icons/types'

export const ciWatersports: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm14.892 21.18 1.552 1.444.4.422a.501.501 0 0 0 .356.155.488.488 0 0 0 .488-.554 6.663 6.663 0 0 1 0-1.467h-2.796Zm7.871-3.108a.494.494 0 0 0-.446-.281H10.58a13.768 13.768 0 0 1 9.164-3.53h.023a.492.492 0 0 0 .45-.684L15.952 3.428a.49.49 0 0 0-.356-.29l-2.949-.591c.164-.347.338-.689.516-1.026a.492.492 0 1 0-.867-.464 25.196 25.196 0 0 0-.821 1.678 25.68 25.68 0 0 0-1.1 2.953h3.275a.492.492 0 0 1 0 .984h-3.558c-.182.7-.337 1.4-.459 2.11h5.892a.492.492 0 0 1 0 .984H9.478a26.01 26.01 0 0 0-.164 1.58l-.028.44h5.2a.493.493 0 0 1 0 .985H9.253a29.702 29.702 0 0 0 .3 4.893.419.419 0 0 0 .033.127h-7.9a.491.491 0 0 0-.258.909 12.126 12.126 0 0 0 6.394 1.875h11a5.036 5.036 0 0 0 3.878-1.983.5.5 0 0 0 .063-.52Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'watersports',
  type: 'solid'
}
